import InputForm from '../../InputT';
import SearInputM from '../../SearchModal';
import { useTranslation } from 'react-i18next';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import { Box } from '@mui/material';
import SearchInput from '../../SearchInput';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthUser } from '../../../Services/Auth/sessionAuth';
import CheckboxF from '../../ChexBox';
// const Swal = require('sweetalert2');
//import linkt = React.lazy(() => import('./questions'));
// let Link = require('../../../Data/Data.json');

//Initialisation des parametres de recherche
let searchNumCompte: ParamsPicklist = { CodeAgence: "", Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "", Choix: 22 }
let searchTypeCompte: ParamsPicklist = { CodeAgence: "", Table: "TYPECPT", Colonne1: "CODTYP", Colonne2: "LIBELLE", Colagence: "", Choix: 22 }
let searchDevise: ParamsPicklist = { CodeAgence: "", Table: "DEVISE", Colonne1: "CODDEV", Colonne2: "LIBELL", Colagence: "", Choix: 22 }
let searchAgence: ParamsPicklist = { CodeAgence: "", Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: "", Choix: 22 }
let searchClient: ParamsPicklist = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '', Choix: 22 }
let searchComptegroupe: ParamsPicklist = { CodeAgence: "", Table: "", Colonne1: "idplan", Colonne2: "LIBELL", Colagence: "", Choix: 22 }
let searchTypesignature: ParamsPicklist = { CodeAgence: "", Table: "TYPESIGN", Colonne1: "CODETYP", Colonne2: "LIBELLE", Colagence: "", Choix: 22 }
let searchPlanComptable: ParamsPicklist = { CodeAgence: "", Table: "plancp", Colonne1: "idplan", Colonne2: "LIBELL", Colagence: "", Choix: 22 }
let searchGestionnaire: ParamsPicklist = { CodeAgence: '', Table: "GESTIONNAIRE", Colonne1: "CODGES", Colonne2: "LIBELLE", Colagence: '001', Choix: 22 }
//ancien compte
let searchPays: ParamsPicklist = { CodeAgence: '', Table: "CDPAYS", Colonne1: "CDPAYS", Colonne2: "LIBELL", Colagence: '001', Choix: 22 }
let searchActivite: ParamsPicklist = { CodeAgence: '', Table: "TABNAE", Colonne1: "CODNAE", Colonne2: "LIBELL", Colagence: '001', Choix: 22 }
let searchClassRisque: ParamsPicklist = { CodeAgence: '', Table: "CLARIS", Colonne1: "CLARIS", Colonne2: "LIBELLFR", Colagence: '001', Choix: 22 }
let searchNiveauInstruction: ParamsPicklist = { CodeAgence: '', Table: "INSTRU", Colonne1: "CODINS", Colonne2: "LIBELL", Colagence: '001', Choix: 22 }
let searchEthnie: ParamsPicklist = { CodeAgence: '', Table: "ETHNIE", Colonne1: "CODETH", Colonne2: "LIBELL", Colagence: '001', Choix: 22 }
let searchCateGo: ParamsPicklist = { CodeAgence: '', Table: "CATEGO", Colonne1: "CATEGO", Colonne2: "LIBELLFR", Colagence: '001', Choix: 22 }
let searchZoneGeo: ParamsPicklist = { CodeAgence: '', Table: "RESIDE", Colonne1: "CDRESI", Colonne2: "LIBELLFR", Colagence: '001', Choix: 22 }

const Tab1 = (props: { etatG?: boolean, form?: any, Function1?: any, Function2?: any }) => {

  // const datas: DataType[] = [];
  //const {t,i18n}=useTranslation();
  const { t, i18n } = useTranslation();
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  //information du client
  let informationclient = {
    searchNumeroCompte: {
      Titre: "Recherche Numéro de Compte",
      label: "Numéro Compte",
      name: "NUMCPT", params: searchNumCompte
    },
    searchTypeCompte: {
      Titre: "Recherche Type de Compte",
      label: "Type Compte",
      name: "TYPCPT", params: searchTypeCompte
    },
    searchDevise: {
      Titre: "Recherche Dévise",
      label: "dévise",
      name: "CDDEVS", params: searchDevise
    },
    searchAgence: {
      Titre: "Recherche Agence",
      label: "Agence",
      name: "AGCCPT", params: searchAgence
    },
    SearchClient: {
      Titre: " Recherche Indice Client",
      label: "Indice Client",
      name: "NUMCLI", params: searchClient
    },
    Inputcle: {
      label: "Cle",
      name: "CLECLI"
    },
    searchPlanComptable: {
      Titre: "Recherche Plan Comptable",
      label: "Plan Comptable",
      name: "IDPLAN", params: searchPlanComptable
    },
    searchCompteg: {
      Titre: "Recherche Compte de Groupe",
      label: "Compte de Groupe",
      name: "CPTREGPT", params: searchComptegroupe
    },
    //--audit
    InputNom: {
      label: "Nom Client",
      name: "NOMCPT"
    },
    InputTelCpt: {
      label: "Tel Mobile",
      name: "TelMobil"
    },
    searchTypesignature: {
      Titre: "Recherche Type Signature",
      label: "Type Signature",
      name: "typSignature", params: searchTypesignature
    },
    //--audit
    SearchGestionnaire: {
      Titre: "Recherche Gestionnaire",
      label: "Gestionnaire",
      name: "cdgest", params: searchGestionnaire
       //suspend
    },
    SearchNationnalite: {
      Titre: "Recherche Nationnalité",
      label: "Nationnalité",
      name: "CDPAYS", params: searchPays
    },
    SearchActivite: {
      Titre: "Recherche Activité ",
      label: "Activité ",
      name: "CDENA", params: searchActivite
    },
    SearchClaris: {
      Titre: "Recherche Classification Risque",
      label: "Classification Risque",
      name: "CLARIS", params: searchClassRisque
    },
    SearchNiveauInstruction: {
      Titre: "Recherche Niveau Instruction",
      label: "Niveau Instruction",
      name: "INSTRU", params: searchNiveauInstruction
    },
    SearchEthnie: {
      Titre: t("FormClientPhysique.informationclient.SearchEthnie.Titre"),
      label: t("FormClientPhysique.informationclient.SearchEthnie.label"),
      name: "ETHNIE", params: searchEthnie
    },
    SearchActiviteEconomique: {
      Titre: "Recherche Activité Economique",
      label: "Activité Economique",
      name: "CDENAE", params: searchActivite
    },
    SearchCatego: {
      Titre: t("FormClientPhysique.informationclient.SearchCatego.Titre"),
      label: t("FormClientPhysique.informationclient.SearchCatego.label"),
      name: "categocpt", params: searchCateGo
    },
    SearchZoneGeo: {
      Titre: "Recherche Zone Geographique",
      label: "Zone Géographique",
      name: "reside", params: searchZoneGeo
    }

  }

  return (

    <div className='tabItem' >
      <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"}>
        <legend>Parametres Comptes </legend>
        <Box style={{ display: 'flex' }}   >
          <Box fontStyle="inherit" className='border-left '>
            <SearInputM width={9} Titre={informationclient.searchTypeCompte.Titre} label={informationclient.searchTypeCompte.label} name={informationclient.searchTypeCompte.name} Parametre={informationclient.searchTypeCompte.params} form={props.form} />
          </Box>
          <Box fontStyle="inherit" className='border-left'>
            <SearInputM width={9} Titre={informationclient.searchDevise.Titre} label={informationclient.searchDevise.label} name={informationclient.searchDevise.name} Parametre={informationclient.searchDevise.params} form={props.form} />
          </Box>
        </Box>
        <legend>Information du Compte</legend>
        <Box style={{ display: 'flex' }}   >
          <Box fontStyle="inherit" className='border-left '>
            <SearchInput notRequired width={8} Titre={informationclient.searchNumeroCompte.Titre} label={informationclient.searchNumeroCompte.label} name={informationclient.searchNumeroCompte.name} Parametre={informationclient.searchNumeroCompte.params} form={props.form} />
            <SearInputM width={8} Titre={informationclient.SearchClient.Titre} label={informationclient.SearchClient.label} name={informationclient.SearchClient.name} Parametre={informationclient.SearchClient.params} form={props.form} ExecuteafterSelect2={props.Function2} />
            <InputForm width={8} label={informationclient.InputNom.label} name={informationclient.InputNom.name} type='text' error='ce Champ est obligatoire' />
            <SearInputM notRequired disabled width={8} Titre={informationclient.SearchGestionnaire.Titre} label={'compte d\'Amortissement'} name={informationclient.SearchGestionnaire.name} Parametre={informationclient.SearchGestionnaire.params} form={props.form} />
          </Box>
          <Box fontStyle="inherit" className='border-left'>
            <SearInputM width={8} Titre={informationclient.searchPlanComptable.Titre} label={informationclient.searchPlanComptable.label} name={informationclient.searchPlanComptable.name} Parametre={informationclient.searchPlanComptable.params} form={props.form} />
            <InputForm width={8} label={informationclient.Inputcle.label} name={informationclient.Inputcle.name} type='text' error='ce Champ est obligatoire' />
            <InputForm width={8} name='indicemanuelle' label='Indice manuel' type='text' />
            <SearInputM notRequired disabled width={8} Titre={informationclient.SearchGestionnaire.Titre} label={informationclient.SearchGestionnaire.label} name={informationclient.SearchGestionnaire.name} Parametre={informationclient.SearchGestionnaire.params} form={props.form} />
          </Box>
        </Box>
        <Box style={{ display: 'flex' }}   >
          <Box fontStyle="inherit" className='border-left '>
              <InputForm width={8} name='Nom ou Raison Social' label='Nom ou Raison Social' type='text' /> 
              <SearInputM notRequired disabled width={8}  Titre={informationclient.SearchActivite.Titre} label={informationclient.SearchActivite.label} name={informationclient.SearchActivite.name} Parametre={informationclient.SearchActivite.params} form={props.form} />
              <SearInputM notRequired disabled width={8}  Titre={informationclient.SearchCatego.Titre} label={informationclient.SearchCatego.label} name={informationclient.SearchCatego.name} Parametre={informationclient.SearchCatego.params} form={props.form} />
          </Box>
          <Box fontStyle="inherit" className='border-left'    left={2}>
              <SearInputM notRequired disabled width={8}  Titre={informationclient.SearchGestionnaire.Titre} label={informationclient.SearchGestionnaire.label} name={informationclient.SearchGestionnaire.name} Parametre={informationclient.SearchGestionnaire.params} form={props.form} />
              <SearInputM notRequired disabled width={8}  Titre={informationclient.SearchNiveauInstruction.Titre} label={informationclient.SearchNiveauInstruction.label} name={informationclient.SearchNiveauInstruction.name} Parametre={informationclient.SearchNiveauInstruction.params} form={props.form} />
              <SearInputM notRequired disabled width={8}  Titre={informationclient.SearchEthnie.Titre} label={informationclient.SearchEthnie.label} name={informationclient.SearchEthnie.name} Parametre={informationclient.SearchEthnie.params} form={props.form} />
           
          </Box>
        </Box>


      </Box>

    </div>
  );
}

export default Tab1;